"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.emptyFilterData = void 0;
exports.emptyFilterData = { operator: "and", fields: [] };
